import LeadForm from '@/components/shared/LeadForm';
import SEO from '@/components/shared/SEO';
import { heroImages } from '@/data/images';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';

export default function ContactPage() {
  return (
    <div data-testid="contact-page">
      <SEO
        title="Contact Us - Get Expert Trademark Advice"
        description="Get in touch with Trademark Pact's trademark specialists. We're here to answer your questions and guide you through the registration process. Contact us today."
      />
      <section className="relative pt-28 pb-12 lg:pt-36 lg:pb-24 overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img src={heroImages.contact} alt="" className="w-full h-full object-cover" loading="eager" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#064E3B]/95 via-[#064E3B]/80 to-[#064E3B]/50" />
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="max-w-3xl">
            <span className="text-emerald-300 font-semibold text-sm tracking-wider uppercase">Contact Us</span>
            <h1 className="font-heading font-extrabold text-4xl sm:text-5xl lg:text-6xl text-white leading-tight tracking-tight mt-3 mb-6">
              Ready to Protect What You've Built?
            </h1>
            <p className="text-emerald-100 text-base lg:text-lg leading-relaxed">
              Have questions about trademark registration or any of our services? Our team is ready to help. Reach out and we'll get back to you promptly.
            </p>
          </div>
        </div>
      </section>

      <section className="py-12 lg:py-28 bg-white" data-testid="contact-form-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-16">
            <div>
              <h2 className="font-heading font-bold text-2xl text-[#064E3B] mb-8">Get In Touch</h2>
              <div className="space-y-6">
                <div className="flex gap-4">
                  <div className="w-12 h-12 rounded-xl bg-emerald-50 flex items-center justify-center shrink-0">
                    <MapPin className="w-5 h-5 text-[#064E3B]" />
                  </div>
                  <div>
                    <h3 className="font-heading font-semibold text-sm text-[#064E3B] mb-1">Address</h3>
                    <p className="text-sm text-slate-600">18952 MacArthur Blvd Suite 100, Irvine, CA 92612</p>
                  </div>
                </div>
                <div className="flex gap-4">
                  <div className="w-12 h-12 rounded-xl bg-emerald-50 flex items-center justify-center shrink-0">
                    <Mail className="w-5 h-5 text-[#064E3B]" />
                  </div>
                  <div>
                    <h3 className="font-heading font-semibold text-sm text-[#064E3B] mb-1">Email</h3>
                    <p className="text-sm text-slate-600">info@trademarkpact.com</p>
                  </div>
                </div>
                <div className="flex gap-4">
                  <div className="w-12 h-12 rounded-xl bg-emerald-50 flex items-center justify-center shrink-0">
                    <Phone className="w-5 h-5 text-[#064E3B]" />
                  </div>
                  <div>
                    <h3 className="font-heading font-semibold text-sm text-[#064E3B] mb-1">Phone</h3>
                    <p className="text-sm text-slate-600">+1 (877) 685-1682</p>
                  </div>
                </div>
                <div className="flex gap-4">
                  <div className="w-12 h-12 rounded-xl bg-emerald-50 flex items-center justify-center shrink-0">
                    <Clock className="w-5 h-5 text-[#064E3B]" />
                  </div>
                  <div>
                    <h3 className="font-heading font-semibold text-sm text-[#064E3B] mb-1">Business Hours</h3>
                    <p className="text-sm text-slate-600">Monday - Friday: 9:00 AM - 6:00 PM EST</p>
                    <p className="text-sm text-slate-600">Saturday: 10:00 AM - 2:00 PM EST</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-2xl border border-emerald-100 p-8 shadow-sm" data-testid="contact-form-card">
              <h2 className="font-heading font-bold text-xl text-[#064E3B] mb-6">Send Us a Message</h2>
              <LeadForm packageTitle="Essentials" packageAmount={45} />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
